let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("7tnr1"), load("u2Avf"), load("ixaXv")]).then(() => parcelRequire('diWiU'));